<script setup lang="ts">
import { defineEmits } from "vue";

const props = withDefaults(defineProps<{ isOpened: boolean }>(), {
  isOpened: false,
});

const emit = defineEmits(['toggle']);

const toggle = () => {
  emit('toggle', !props.isOpened);
};
</script>

<template>
  <div class="block">
    <button class="burger-menu bg-cyan rounded-6" @click="toggle" :class="{'active' : isOpened}">
      <span></span>
    </button>
  </div>
</template>

<style lang="scss" scoped>

.burger-menu {
  position: relative;
  display: block;
  border: 0;
  width: 2.5rem;
  height: 2.5rem;
  cursor: pointer;
  appearance: none;

  &::after,
  &::before {
    content: "";
  }

  span,
  &::after,
  &::before {
    backface-visibility: hidden;
    position: absolute;
    left: 0.4rem;
    right: 0.4rem;
    border-top: 0.2rem solid var(--color-dark-blue);
    border-radius: 0.8rem;
    transition: 0.2s;
  }

  &::before {
    top: .7rem;
  }
  span {
    top: 1.25rem;
  }
  &::after {
    top: 1.8rem;
  }

  &.active {
    &::before,
    &::after {
      top: 1.25rem;
      transition: 0.3s;
    }

    &::before {
      transform: rotate(45deg);
    }

    span {
      opacity: 0;
    }

    &::after {
      transform: rotate(-45deg);
    }
  }
}
</style>
